import { render, staticRenderFns } from "./TqLongText.vue?vue&type=template&id=cfcb6bae&scoped=true&"
import script from "./TqLongText.vue?vue&type=script&lang=js&"
export * from "./TqLongText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfcb6bae",
  null
  
)

export default component.exports